import { getCookie } from '../../../common/utils';

/** Org id used when creating/listing CAP endpoints — aligns with DAS list (groupId cookie). */
export const getCapOrgId = (): string =>
  getCookie('groupId') || getCookie('organizationId') || '';
